export { default as ContentfulHomePage } from 'components/ContentfulHomePage/ContentfulHomePage';
export { default as ContentfulProductCarousel } from 'components/ContentfulHomePage/ContentfulProductCarousel';
export * as Styled from './ContentfulHomePage.styles';
